import React, { useState, useEffect } from "react";
// Utils
import { GetStockItem_stockItem_lineItems } from "api/Medicine/types/GetStockItem";
import { useEventRequest } from "hooks";
// Components
import { BatchActivities } from "medicines/components/MedicineTabsBlock/BatchActivities";
import { BatchDetails } from "medicines/components/MedicineTabsBlock/BatchDetails";
import { Flex, Spacer, Title, VerticalTabs } from "components";
// Resources
import styles from "./MedicineTabsBlock.module.scss";

type MedicineTabsBlockProps = {
  lineItems: GetStockItem_stockItem_lineItems[];
};

export const MedicineTabsBlock: React.FC<MedicineTabsBlockProps> = ({ lineItems }) => {
  const { eventsRequest } = useEventRequest();

  const [activeBatch, setActiveBatch] = useState<string>(lineItems[0].id);
  const currentBatch = lineItems.find((item) => item.id === activeBatch);

  useEffect(() => {
    if (activeBatch) {
      eventsRequest({ name: "med-cab-batch-view", details: { activeBatch } });
    }
  }, [activeBatch]);

  const batchTabs = lineItems.map((item) => ({
    active: item.id === activeBatch,
    caption: item.batchNumber,
    id: item.id,
    onTabChange: setActiveBatch,
  }));

  return (
    <>
      <VerticalTabs tabs={batchTabs} tabsTitle="Select batch:">
        <Flex className={styles.medicine_tabs_block__activity} item xs={6}>
          <Spacer allowDecimal baselineHeight={2.5} />

          <Title tertiary>Usage history</Title>

          <Spacer allowDecimal baselineHeight={2.5} />

          <BatchActivities batchNumber={currentBatch?.batchNumber} />

          <Spacer baselineHeight={3} />
        </Flex>

        <Flex className={styles.medicine_tabs_block__batch} item xs={3}>
          <Spacer allowDecimal baselineHeight={2.5} />

          <Title tertiary>Batch details</Title>

          <Spacer allowDecimal baselineHeight={2.5} />

          <BatchDetails batch={currentBatch} />

          <Spacer baselineHeight={3} />
        </Flex>
      </VerticalTabs>
    </>
  );
};
